// extracted by mini-css-extract-plugin
module.exports = {"squareButton":"_b3cb9b6","text":"_2e25880"};